<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="终端主机号/车牌号/车架号"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 10px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click=onprocessAnalysisResult>批量处理</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)" @on-select="onselect"
                 @on-select-all="onselectall"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator show-sizer
              @on-change="setPage" @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <process-alarm-modal v-model="processAlarmModal" :initValue="processAlarmId" @on-success="onModifySuccess"></process-alarm-modal>
    <batch-process-alarm-modal v-model="batchProcessAlarmModal" :initValue="batchProcessAlarmId" @on-success="onModifySuccess"></batch-process-alarm-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import ProcessAttentionVehicleModal from '@/view/da/components/process-attention-vehicle-modal'
import BatchProcessAttentionVehicleModal from '@/view/da/components/batch-process-attention-vehicle-modal'

export default {
  name: 'duplicateterminalnumanalysisresults',
  components: {
    ProcessAttentionVehicleModal,
    BatchProcessAttentionVehicleModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 备注
      processAttentionVehicleModal: false,
      processAttentionVehicleId: null,

      // 批量追加备注
      batchprocessAttentionVehicleModal: false,
      batchprocessAttentionVehicleId: null,

      stateFilter: null,

      keywordFilter: null,
      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      showNormal: false,

      /**
         * 多选列表
         */
      processAnalysisResultList: [],

      columns: [
        {
          width: 55,
          type: 'selection'
        },
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '车牌号',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          render: (h, params) => {
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.registrationNum) {
                return h('div', params.row.vehicleInfo.registrationNum)
              } else {
                return h('div', '无')
              }
            } else {
              return h('div', '未绑定车辆信息')
            }
          }
        },
        {
          title: '车架号',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.vin) {
                return h('div', params.row.vehicleInfo.vin)
              } else {
                return h('div', '无')
              }
            } else {
              return h('div', '未绑定车辆信息')
            }
          }
        },
        {
          title: '终端主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          tooltip: 'true',
          width: 140,
          render: (h, params) => {
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.positioningDeviceInfos) {
                // return h('div', params.row.vehicleInfo.positioningDeviceInfos[0].positioningDeviceModel.name)
                let display = []
                display.push(h('div', params.row.terminalNum))
                if (params.row.vehicleInfo.positioningDeviceInfos[0]) {
                  let positioningDeviceInfo = params.row.vehicleInfo.positioningDeviceInfos[0]
                  display.push(h('div', '终端型号:' + (positioningDeviceInfo.positioningDeviceModel.name == null ? '' : positioningDeviceInfo.positioningDeviceModel.name)))
                }
                return h('div', display)
              } else {
                return h('div', '无')
              }
            } else {
              return h('div', '未绑定车辆信息')
            }
          }
        },
        {
          title: '重复数据项',
          resizable: true,
          key: 'duplicateTerminalNumInfoListJson',
          ellipsis: 'true',
          tooltip: 'true',
          width: 360,
          render: (h, params) => {
            let disp = []
            let js = JSON.parse(params.row.duplicateTerminalNumInfoListJson)
            for (let item of js) {
              disp.push(h('div', 'iccid:' + item.iccid + ',simNum:' + item.simNum))
            }
            return h('div', disp)
          }
        },
        {
          title: '终端型号',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 170,
          render: (h, params) => {
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.positioningDeviceInfos) {
                let positioningDeviceInfo = params.row.vehicleInfo.positioningDeviceInfos[0]
                let display = []
                display.push(h('div', '业务类型:' + (positioningDeviceInfo.isfree == 1 ? '自费模式' : positioningDeviceInfo.isfree == 2 ? '普通免费' : positioningDeviceInfo.isfree == 3 ? '太好保模式' : '无')))
                display.push(h('div', '服务到费期:' + (positioningDeviceInfo.serviceDatetime == null ? '' : new Date(positioningDeviceInfo.serviceDatetime).Format('yyyy-MM-dd'))))
                return h('div', display)
              } else {
                return h('div', '无')
              }
            } else {
              return h('div', '未绑定车辆信息')
            }
          }
        },
        {
          title: '车辆分组',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          render: (h, params) => {
            if (params.row.vehicleInfo) {
              if (params.row.vehicleInfo.vehicleInfoGroup) {
                return h('div', params.row.vehicleInfo.vehicleInfoGroup.name)
              } else {
                return h('div', '无')
              }
            } else {
              return h('div', '未绑定车辆信息')
            }
          }
        },
        {
          title: '状态',
          resizable: true,
          key: 'state',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '未绑定终端', value: 1 },
            { label: '离线', value: 2 },
            { label: '报警', value: 3 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
          },
          render: (h, params) => {
            let state = params.row.state
            if (state === 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '未绑定终端')
              ])
            } else if (state === 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '离线')
              ])
            } else if (state === 3) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '报警')
              ])
            }
          }
        },
        {
          title: '是否恢复正常',
          resizable: true,
          key: 'normal',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 130,
          render: function (h, params) {
            if (params.row.normal) {
              return h('div', '是')
            } else {
              return h('div', '否')
            }
          }
        },
        {
          title: '更新时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'updateDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '分析时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'analyzeDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.analyzeDatetime) {
              let d = new Date(params.row.analyzeDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '观察时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'observationDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.observationDatetime) {
              let d = new Date(params.row.observationDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '历史备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'historyProcessRemark',
          width: 180
        },
        {
          title: '备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 180
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          minWidth: 90,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.processAttentionVehicleId = params.row.id
                    this.processAttentionVehicleModal = true
                  }
                }
              }, '追加备注')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'ClientInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onFilterClick () {
      this.setPage(1)
    },
    filterChange () {
      this.setPage(1)
    },
    onselect (selection, row) {
      this.processAnalysisResultList = []
      selection.forEach(item => {
        this.processAnalysisResultList.push(item.id)
      })
    },
    onselectall (selection) {
      this.processAnalysisResultList = []
      selection.forEach(item => {
        this.processAnalysisResultList.push(item.id)
      })
    },
    onprocessAnalysisResult () {
      /**
         * 给id列表
         * 给处理内容
         * 后端批量处理
         */
      this.batchprocessAttentionVehicleModal = true
      this.batchprocessAttentionVehicleId = this.processAnalysisResultList
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    setPage (page) {
      // let a = '[{\"iccid\":\"898602111192080048977\",\"simNum\":null,\"registrationNum\":null,\"vin\":null,\"times\":1,\"updated\":true},{\"iccid\":\"898602111192080049077\",\"simNum\":null,\"registrationNum\":null,\"vin\":null,\"times\":1,\"updated\":true}]'
      // let b = JSON.parse(a)
      // console.log(b)
      // for(let i of b){
      //   console.log(i)
      // }

      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null
      let qo1 = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      }

      // if (!this.showNormal) {
      //   queryParams.push(genQueryParam('normal', 'EQ', 0))
      // }

      store.dispatch('DuplicateTerminalNumAnalysisResultServ_GetPage', {
        params: null,
        urlparams: {
          qo1: qo1,
          q: queryParams,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    totalElements () {
      if (store.getters.get_DuplicateTerminalNumAnalysisResult_GetPageResult) {
        return store.getters.get_DuplicateTerminalNumAnalysisResult_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_DuplicateTerminalNumAnalysisResult_GetPageResult) {
        return store.getters.get_DuplicateTerminalNumAnalysisResult_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_DuplicateTerminalNumAnalysisResult_GetPageResult) {
        return store.getters.get_DuplicateTerminalNumAnalysisResult_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 160
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
